module.exports = __webpack_public_path__ + "static/media/ball-pile.4088e34a.svg";